export default __webpack_public_path__ + "static/media/014-lighthouse-1.166fa7f3.png";